<div *ngIf="reportType == 'indetailcontract'">
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
            Export
        </button>
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>

    <div class="table-wrapper" id="print-section">
        <table class="table table-bordered fixed-columns-table">
            <thead>
                <tr>
                    <th colspan="11" class="fixed-header" style="border-top: 2px solid #000;
        border-bottom: 2px solid #000;
        border-left: 2px solid #000  ;
        border-right: 2px solid #000">
                        सा. विवेक जाहिरात वार्षिक करार {{ selectedYear }}-{{ selectedYear + 1 }} नोंदणी तक्ता
                    </th>
                    <th colspan="4">Indetail-contract</th>
                    <th *ngIf="totalweeks == 54" colspan="131"></th>
                    <th *ngIf="totalweeks == 53" colspan="130"></th>
                    <th *ngIf="totalweeks == 52" colspan="129"></th>
                </tr>
                <tr>
                    <th rowspan="3" class="fixed-col col-1">अक्र.</th>
                    <th rowspan="3" class="fixed-col col-2">जाहिरात कराराचे नाव</th>
                    <th rowspan="3" class="fixed-col col-3">प्रतिनिधी</th>
                    <th rowspan="3" class="fixed-col col-4">करार कालावधी</th>
                    <th rowspan="3" class="fixed-col col-5">शिल्लक करार</th>
                    <th rowspan="3" class="fixed-col col-7">नवीन करार</th>
                    <th rowspan="3" class="fixed-col col-8">एजन्सी सूट</th>
                    <th rowspan="3" class="fixed-col col-9">एकूण</th>
                    <th rowspan="3" class="fixed-col col-10">जी एस टी</th>
                    <th rowspan="3" class="fixed-col col-11">एकूण</th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 3) == 5" colspan="12">एप्रिल {{ today | date:"yyyy" }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 3) == 4" colspan="10">एप्रिल {{ today | date:"yyyy" }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 4) == 5" colspan="12">मे {{ today | date:"yyyy" }}</th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 4) == 4" colspan="10">मे {{ today | date:"yyyy" }}</th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 5) == 5" colspan="12">जुन {{ today | date:"yyyy" }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 5) == 4" colspan="10">जुन {{ today | date:"yyyy" }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 6) == 5" colspan="12">जुलै {{ today | date:"yyyy" }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 6) == 4" colspan="10">जुलै {{ today | date:"yyyy" }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 7) == 5" colspan="12">ऑगस्ट{{ today | date:"yyyy" }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 7) == 4" colspan="10">ऑगस्ट {{ today | date:"yyyy" }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 8) == 5" colspan="12">सप्टेंबर {{ today | date:"yyyy"
                        }}</th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 8) == 4" colspan="10">सप्टेंबर {{ today | date:"yyyy"
                        }}</th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 9) == 5" colspan="12">ऑक्टोबर {{ today | date:"yyyy" }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 9) == 4" colspan="10">ऑक्टोबर {{ today | date:"yyyy" }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 10) == 5" colspan="12">नोव्हेंबर {{ today | date:"yyyy"
                        }}</th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 10) == 4" colspan="10">नोव्हेंबर {{ today | date:"yyyy"
                        }}</th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 11) == 5" colspan="12">डिसेंबर {{ today | date:"yyyy"
                        }}</th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 11) == 4" colspan="10">डिसेंबर {{ today | date:"yyyy"
                        }}</th>
                    <th *ngIf="this.sundays(nexttoday | date:'yyyy', 0) == 5" colspan="12">जानेवारी {{ nexttoday |
                        date:"yyyy" }}</th>
                    <th *ngIf="this.sundays(nexttoday | date:'yyyy', 0) == 4" colspan="10">जानेवारी {{ nexttoday |
                        date:"yyyy" }}</th>
                    <th *ngIf="this.sundays(nexttoday | date:'yyyy', 1) == 5" colspan="12">फेब्रुवारी {{ nexttoday |
                        date:"yyyy" }}</th>
                    <th *ngIf="this.sundays(nexttoday | date:'yyyy', 1) == 4" colspan="10">फेब्रुवारी {{ nexttoday |
                        date:"yyyy" }}</th>
                    <th *ngIf="this.sundays(nexttoday | date:'yyyy', 2) == 5" colspan="12">मार्च {{ nexttoday |
                        date:"yyyy" }}</th>
                    <th *ngIf="this.sundays(nexttoday | date:'yyyy', 2) == 4" colspan="10">मार्च {{ nexttoday |
                        date:"yyyy" }}</th>
                    <th rowspan="3">एकूण मार्च <br> अखेर</th>
                    <th rowspan="3">पुढील <br>वर्षासाठी</th>
                    <th rowspan="3">आज <br>अखेर वापरले</th>
                    <th rowspan="3">मार्च अखेर<br> वापरणे बाकी</th>
                </tr>
                <tr>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 3) > 4" colspan="2"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 4) > 4" colspan="2"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 5) > 4" colspan="2"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 6) > 4" colspan="2"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 7) > 4" colspan="2"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 8) > 4" colspan="2"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 9) > 4" colspan="2"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th *ngIf="this.sundays(today | date:'yyyy',10) > 4" colspan="2"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 11) > 4" colspan="2"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th *ngIf="this.sundays(nexttoday | date:'yyyy', 0) > 4" colspan="2"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2" *ngIf="this.sundays(nexttoday | date:'yyyy', 1) > 4"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2" *ngIf="this.sundays(nexttoday | date:'yyyy', 2) > 4"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                </tr>
                <tr>
                    <th class="date-header" colspan="2">{{ firstSunday(3,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ secondSunday(3,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ thirdSunday(3,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ fourthSunday(3,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" *ngIf="this.sundays(today | date:'yyyy', 3) > 4" colspan="2">{{
                        fifthSunday(3,today | date:"yyyy") | date:"dd/MM/yy" }}</th>

                    <th class="date-header" colspan="2">{{ firstSunday(4,today | date:"yyyy")| date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ secondSunday(4,today | date:"yyyy")| date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ thirdSunday(4,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ fourthSunday(4,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" *ngIf="this.sundays(today | date:'yyyy', 4) > 4" colspan="2">{{
                        fifthSunday(4,today | date:"yyyy") | date:"dd/MM/yy" }}</th>

                    <th class="date-header" colspan="2">{{ firstSunday(5,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ secondSunday(5,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ thirdSunday(5,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ fourthSunday(5,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" *ngIf="this.sundays(today | date:'yyyy', 5) > 4" colspan="2">{{
                        fifthSunday(5,today | date:"yyyy") | date:"dd/MM/yy" }}</th>

                    <th class="date-header" colspan="2">{{ firstSunday(6,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ secondSunday(6,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ thirdSunday(6,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ fourthSunday(6,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" *ngIf="this.sundays(today | date:'yyyy', 6) > 4" colspan="2">{{
                        fifthSunday(6,today | date:"yyyy") | date:"dd/MM/yy" }}</th>

                    <th class="date-header" colspan="2">{{ firstSunday(7,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ secondSunday(7,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ thirdSunday(7,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ fourthSunday(7,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" *ngIf="this.sundays(today | date:'yyyy', 7) > 4" colspan="2">{{
                        fifthSunday(7,today | date:"yyyy") | date:"dd/MM/yy" }}</th>

                    <th class="date-header" colspan="2">{{ firstSunday(8,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ secondSunday(8,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ thirdSunday(8,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ fourthSunday(8,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" *ngIf="this.sundays(today | date:'yyyy', 8) > 4" colspan="2">{{
                        fifthSunday(8,today | date:"yyyy") | date:"dd/MM/yy" }}</th>

                    <th class="date-header" colspan="2">{{ firstSunday(9,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ secondSunday(9,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ thirdSunday(9,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ fourthSunday(9,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" *ngIf="this.sundays(today | date:'yyyy', 9) > 4" colspan="2">{{
                        fifthSunday(9,today | date:"yyyy") | date:"dd/MM/yy" }}</th>

                    <th class="date-header" colspan="2">{{ firstSunday(10,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ secondSunday(10,today | date:"yyyy") | date:"dd/MM/yy" }}
                    </th>
                    <th class="date-header" colspan="2">{{ thirdSunday(10,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ fourthSunday(10,today | date:"yyyy") | date:"dd/MM/yy" }}
                    </th>
                    <th class="date-header" *ngIf="this.sundays(today | date:'yyyy', 10) > 4" colspan="2">{{
                        fifthSunday(10,today | date:"yyyy") | date:"dd/MM/yy" }}</th>

                    <th class="date-header" colspan="2">{{ firstSunday(11,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ secondSunday(11,today | date:"yyyy") | date:"dd/MM/yy" }}
                    </th>
                    <th class="date-header" colspan="2">{{ thirdSunday(11,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th class="date-header" colspan="2">{{ fourthSunday(11,today | date:"yyyy") | date:"dd/MM/yy" }}
                    </th>
                    <th class="date-header" *ngIf="this.sundays(today | date:'yyyy', 11) > 4" colspan="2">{{
                        fifthSunday(11,today | date:"yyyy") | date:"dd/MM/yy" }}</th>

                    <th class="date-header" colspan="2">{{ firstSunday(0,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}
                    </th>
                    <th class="date-header" colspan="2">{{ secondSunday(0,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}
                    </th>
                    <th class="date-header" colspan="2">{{ thirdSunday(0,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}
                    </th>
                    <th class="date-header" colspan="2">{{ fourthSunday(0,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}
                    </th>
                    <th class="date-header" *ngIf="this.sundays(nexttoday | date:'yyyy', 0) > 4" colspan="2">{{
                        fifthSunday(0,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}</th>

                    <th class="date-header" colspan="2">{{ firstSunday(1,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}
                    </th>
                    <th class="date-header" colspan="2">{{ secondSunday(1,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}
                    </th>
                    <th class="date-header" colspan="2">{{ thirdSunday(1,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}
                    </th>
                    <th class="date-header" colspan="2">{{ fourthSunday(1,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}
                    </th>
                    <th class="date-header" *ngIf="this.sundays(nexttoday | date:'yyyy', 1) > 4" colspan="2">{{
                        fifthSunday(1,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}</th>

                    <th class="date-header" colspan="2">{{ firstSunday(2,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}
                    </th>
                    <th class="date-header" colspan="2">{{ secondSunday(2,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}
                    </th>
                    <th class="date-header" colspan="2">{{ thirdSunday(2,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}
                    </th>
                    <th class="date-header" colspan="2">{{ fourthSunday(2,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}
                    </th>
                    <th class="date-header" *ngIf="this.sundays(nexttoday | date:'yyyy', 2) > 4" colspan="2">{{
                        fifthSunday(2,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let group of indetailsData; let groupIndex = index">
                    <ng-container *ngIf="group && group.name && group.data">

                        <!-- Group header row -->
                        <tr [style.background-color]="getGroupColor(groupIndex)">
                            <td style="color: red;" class="fixed-col col-1">{{ groupIndex + 1 }}</td>
                            <td style="color: red;font-size: large;font-weight: 600;" colspan="1"
                                class="fixed-col col-2">{{ group.name }}</td>
                            <td colspan="9" class="fixed-col-group"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 3) == 5" colspan="12"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 3) == 4" colspan="10"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 4) == 5" colspan="12"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 4) == 4" colspan="10"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 5) == 5" colspan="12"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 5) == 4" colspan="10"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 6) == 5" colspan="12"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 6) == 4" colspan="10"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 7) == 5" colspan="12"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 7) == 4" colspan="10"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 8) == 5" colspan="12"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 8) == 4" colspan="10"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 9) == 5" colspan="12"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 9) == 4" colspan="10"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 10) == 5" colspan="12"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 10) == 4" colspan="10"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 11) == 5" colspan="12"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 11) == 4" colspan="10"></td>
                            <td *ngIf="this.sundays(nexttoday | date:'yyyy', 0) == 5" colspan="12"></td>
                            <td *ngIf="this.sundays(nexttoday | date:'yyyy', 0) == 4" colspan="10"></td>
                            <td *ngIf="this.sundays(nexttoday | date:'yyyy', 1) == 5" colspan="12"></td>
                            <td *ngIf="this.sundays(nexttoday | date:'yyyy', 1) == 4" colspan="10"></td>
                            <td *ngIf="this.sundays(nexttoday | date:'yyyy', 2) == 5" colspan="12"></td>
                            <td *ngIf="this.sundays(nexttoday | date:'yyyy', 2) == 4" colspan="10"></td>
                            <td colspan="4"></td>
                        </tr>

                        <!-- Data rows -->
                        <ng-container *ngFor="let data of group.data; let i = index">
                            <tr [style.background-color]="getAdvtColor(data.advt_name)">
                                <td rowspan="2" class="fixed-col col-1"
                                    [style.background-color]="getAdvtColor(data.advt_name)">{{ i+1 }}</td>
                                <td rowspan="2" class="fixed-col col-2"
                                    [style.background-color]="getAdvtColor(data.advt_name)">{{ data['advt_name'] }}</td>
                                <td rowspan="2" class="fixed-col col-3"
                                    [style.background-color]="getAdvtColor(data.advt_name)">{{ data['rep_name'] }}</td>
                                <td rowspan="2" class="fixed-col col-4"
                                    [style.background-color]="getAdvtColor(data.advt_name)">

                                    <!-- ✅ Multiple periods: show each on its own line -->
                                    <ng-container *ngIf="data['_all_periods'] && data['_all_periods'].length > 1">
                                        <div *ngFor="let period of data['_all_periods']" style="line-height: 1.6;">
                                            {{ period.from | date:"MM yyyy" }} to {{ period.to | date:"MM yyyy" }}
                                        </div>
                                    </ng-container>

                                    <!-- ✅ Single period: original display -->
                                    <ng-container *ngIf="!data['_all_periods'] || data['_all_periods'].length <= 1">
                                        {{ data['contract_period_from'] | date:"MM yyyy" }} to {{
                                        data['contract_period_to'] | date:"MM yyyy" }}
                                    </ng-container>

                                </td>
                                <td rowspan="2" class="amount fixed-col col-5" style="text-align: end;"
                                    [style.background-color]="getAdvtColor(data.advt_name)">{{ data['contract_prev_bal']
                                    }}</td>
                                <td rowspan="2" class="amount fixed-col col-7" style="text-align: end;"
                                    [style.background-color]="getAdvtColor(data.advt_name)">{{ data['contract_amt'] }}
                                </td>
                                <td rowspan="2" class="amount fixed-col col-8" style="text-align: end;"
                                    [style.background-color]="getAdvtColor(data.advt_name)">{{
                                    data['contract_discnt_amt'] }}</td>
                                <td rowspan="2" class="amount fixed-col col-9" style="text-align: end;"
                                    [style.background-color]="getAdvtColor(data.advt_name)">{{ data['contract_net_amt']
                                    }}</td>
                                <td rowspan="2" class="amount fixed-col col-10" style="text-align: end;"
                                    [style.background-color]="getAdvtColor(data.advt_name)">{{
                                    data['contract_net_gst_amt'] }}</td>
                                <td rowspan="2" class="amount fixed-col col-11" style="text-align: end;"
                                    [style.background-color]="getAdvtColor(data.advt_name)">
                                    {{ calculateTotalWithPrevBal(data['contract_prev_bal'], data['contract_net_total'])
                                    }}
                                </td>

                                <!-- APRIL -->
                                <td colspan="2">{{ data['april1stWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['april2ndWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['april3rdWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['april4thWeekIssueName'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 3) > 4" colspan="2">{{
                                    data['april5thWeekIssueName'] }}</td>
                                <td colspan="2" rowspan="2" style="text-align: end;">
                                    <span *ngIf="this.sundays(today | date:'yyyy', 3) == 4">{{
                                        calculateTotalAmount(data['april1stWeekAmt'],data['april2ndWeekAmt'],data['april3rdWeekAmt'],data['april4thWeekAmt'])
                                        }}</span>
                                    <span *ngIf="this.sundays(today | date:'yyyy', 3) == 5">{{
                                        calculateTotalAmount(data['april1stWeekAmt'],data['april2ndWeekAmt'],data['april3rdWeekAmt'],data['april4thWeekAmt'],data['april5thWeekAmt'])
                                        }}</span>
                                </td>

                                <!-- MAY -->
                                <td colspan="2">{{ data['may1stWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['may2ndWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['may3rdWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['may4thWeekIssueName'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 4) > 4" colspan="2">{{
                                    data['may5thWeekIssueName'] }}</td>
                                <td colspan="2" rowspan="2" style="text-align: end;">
                                    <span *ngIf="this.sundays(today | date:'yyyy', 4) == 4">{{
                                        calculateTotalAmount(data['may1stWeekAmt'],data['may2ndWeekAmt'],data['may3rdWeekAmt'],data['may4thWeekAmt'])
                                        }}</span>
                                    <span *ngIf="this.sundays(today | date:'yyyy', 4) == 5">{{
                                        calculateTotalAmount(data['may1stWeekAmt'],data['may2ndWeekAmt'],data['may3rdWeekAmt'],data['may4thWeekAmt'],data['may5thWeekAmt'])
                                        }}</span>
                                </td>

                                <!-- JUNE -->
                                <td colspan="2">{{ data['june1stWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['june2ndWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['june3rdWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['june4thWeekIssueName'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 5) > 4" colspan="2">{{
                                    data['june5thWeekIssueName'] }}</td>
                                <td colspan="2" rowspan="2" style="text-align: end;">
                                    <span *ngIf="this.sundays(today | date:'yyyy', 5) == 4">{{
                                        calculateTotalAmount(data['june1stWeekAmt'],data['june2ndWeekAmt'],data['june3rdWeekAmt'],data['june4thWeekAmt'])
                                        }}</span>
                                    <span *ngIf="this.sundays(today | date:'yyyy', 5) == 5">{{
                                        calculateTotalAmount(data['june1stWeekAmt'],data['june2ndWeekAmt'],data['june3rdWeekAmt'],data['june4thWeekAmt'],data['june5thWeekAmt'])
                                        }}</span>
                                </td>

                                <!-- JULY -->
                                <td colspan="2">{{ data['july1stWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['july2ndWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['july3rdWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['july4thWeekIssueName'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 6) > 4" colspan="2">{{
                                    data['july5thWeekIssueName'] }}</td>
                                <td colspan="2" rowspan="2" style="text-align: end;">
                                    <span *ngIf="this.sundays(today | date:'yyyy', 6) == 4">{{
                                        calculateTotalAmount(data['july1stWeekAmt'],data['july2ndWeekAmt'],data['july3rdWeekAmt'],data['july4thWeekAmt'])
                                        }}</span>
                                    <span *ngIf="this.sundays(today | date:'yyyy', 6) == 5">{{
                                        calculateTotalAmount(data['july1stWeekAmt'],data['july2ndWeekAmt'],data['july3rdWeekAmt'],data['july4thWeekAmt'],data['july5thWeekAmt'])
                                        }}</span>
                                </td>

                                <!-- AUGUST -->
                                <td colspan="2">{{ data['august1stWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['august2ndWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['august3rdWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['august4thWeekIssueName'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 7) > 4" colspan="2">{{
                                    data['august5thWeekIssueName'] }}</td>
                                <td colspan="2" rowspan="2" style="text-align: end;">
                                    <span *ngIf="this.sundays(today | date:'yyyy', 7) == 4">{{
                                        calculateTotalAmount(data['august1stWeekAmt'],data['august2ndWeekAmt'],data['august3rdWeekAmt'],data['august4thWeekAmt'])
                                        }}</span>
                                    <span *ngIf="this.sundays(today | date:'yyyy', 7) == 5">{{
                                        calculateTotalAmount(data['august1stWeekAmt'],data['august2ndWeekAmt'],data['august3rdWeekAmt'],data['august4thWeekAmt'],data['august5thWeekAmt'])
                                        }}</span>
                                </td>

                                <!-- SEPTEMBER -->
                                <td colspan="2">{{ data['september1stWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['september2ndWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['september3rdWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['september4thWeekIssueName'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 8) > 4" colspan="2">{{
                                    data['september5thWeekIssueName'] }}</td>
                                <td colspan="2" rowspan="2" style="text-align: end;">
                                    <span *ngIf="this.sundays(today | date:'yyyy', 8) == 4">{{
                                        calculateTotalAmount(data['september1stWeekAmt'],data['september2ndWeekAmt'],data['september3rdWeekAmt'],data['september4thWeekAmt'])
                                        }}</span>
                                    <span *ngIf="this.sundays(today | date:'yyyy', 8) == 5">{{
                                        calculateTotalAmount(data['september1stWeekAmt'],data['september2ndWeekAmt'],data['september3rdWeekAmt'],data['september4thWeekAmt'],data['september5thWeekAmt'])
                                        }}</span>
                                </td>

                                <!-- OCTOBER -->
                                <td colspan="2">{{ data['october1stWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['october2ndWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['october3rdWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['october4thWeekIssueName'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 9) > 4" colspan="2">{{
                                    data['october5thWeekIssueName'] }}</td>
                                <td colspan="2" rowspan="2" style="text-align: end;">
                                    <span *ngIf="this.sundays(today | date:'yyyy', 9) == 4">{{
                                        calculateTotalAmount(data['october1stWeekAmt'],data['october2ndWeekAmt'],data['october3rdWeekAmt'],data['october4thWeekAmt'])
                                        }}</span>
                                    <span *ngIf="this.sundays(today | date:'yyyy', 9) == 5">{{
                                        calculateTotalAmount(data['october1stWeekAmt'],data['october2ndWeekAmt'],data['october3rdWeekAmt'],data['october4thWeekAmt'],data['october5thWeekAmt'])
                                        }}</span>
                                </td>

                                <!-- NOVEMBER -->
                                <td colspan="2">{{ data['november1stWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['november2ndWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['november3rdWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['november4thWeekIssueName'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 10) > 4" colspan="2">{{
                                    data['november5thWeekIssueName'] }}</td>
                                <td colspan="2" rowspan="2" style="text-align: end;">
                                    <span *ngIf="this.sundays(today | date:'yyyy', 10) == 4">{{
                                        calculateTotalAmount(data['november1stWeekAmt'],data['november2ndWeekAmt'],data['november3rdWeekAmt'],data['november4thWeekAmt'])
                                        }}</span>
                                    <span *ngIf="this.sundays(today | date:'yyyy', 10) == 5">{{
                                        calculateTotalAmount(data['november1stWeekAmt'],data['november2ndWeekAmt'],data['november3rdWeekAmt'],data['november4thWeekAmt'],data['november5thWeekAmt'])
                                        }}</span>
                                </td>

                                <!-- DECEMBER -->
                                <td colspan="2">{{ data['december1stWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['december2ndWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['december3rdWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['december4thWeekIssueName'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 11) > 4" colspan="2">{{
                                    data['december5thWeekIssueName'] }}</td>
                                <td colspan="2" rowspan="2" style="text-align: end;">
                                    <span *ngIf="this.sundays(today | date:'yyyy', 11) == 4">{{
                                        calculateTotalAmount(data['december1stWeekAmt'],data['december2ndWeekAmt'],data['december3rdWeekAmt'],data['december4thWeekAmt'])
                                        }}</span>
                                    <span *ngIf="this.sundays(today | date:'yyyy', 11) == 5">{{
                                        calculateTotalAmount(data['december1stWeekAmt'],data['december2ndWeekAmt'],data['december3rdWeekAmt'],data['december4thWeekAmt'],data['december5thWeekAmt'])
                                        }}</span>
                                </td>

                                <!-- JANUARY -->
                                <td colspan="2">{{ data['january1stWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['january2ndWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['january3rdWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['january4thWeekIssueName'] }}</td>
                                <td *ngIf="this.sundays(nexttoday | date:'yyyy', 0) > 4" colspan="2">{{
                                    data['january5thWeekIssueName'] }}</td>
                                <td colspan="2" rowspan="2" style="text-align: end;">
                                    <span *ngIf="this.sundays(nexttoday | date:'yyyy', 0) == 4">{{
                                        calculateTotalAmount(data['january1stWeekAmt'],data['january2ndWeekAmt'],data['january3rdWeekAmt'],data['january4thWeekAmt'])
                                        }}</span>
                                    <span *ngIf="this.sundays(nexttoday | date:'yyyy', 0) == 5">{{
                                        calculateTotalAmount(data['january1stWeekAmt'],data['january2ndWeekAmt'],data['january3rdWeekAmt'],data['january4thWeekAmt'],data['january5thWeekAmt'])
                                        }}</span>
                                </td>

                                <!-- FEB -->
                                <td colspan="2">{{ data['feb1stWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['feb2ndWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['feb3rdWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['feb4thWeekIssueName'] }}</td>
                                <td *ngIf="this.sundays(nexttoday | date:'yyyy', 1) > 4" colspan="2">{{
                                    data['feb5thWeekIssueName'] }}</td>
                                <td colspan="2" rowspan="2" style="text-align: end;">
                                    <span *ngIf="this.sundays(nexttoday | date:'yyyy', 1) == 4">{{
                                        calculateTotalAmount(data['feb1stWeekAmt'],data['feb2ndWeekAmt'],data['feb3rdWeekAmt'],data['feb4thWeekAmt'])
                                        }}</span>
                                    <span *ngIf="this.sundays(nexttoday | date:'yyyy', 1) == 5">{{
                                        calculateTotalAmount(data['feb1stWeekAmt'],data['feb2ndWeekAmt'],data['feb3rdWeekAmt'],data['feb4thWeekAmt'],data['feb5thWeekAmt'])
                                        }}</span>
                                </td>

                                <!-- MARCH -->
                                <td colspan="2">{{ data['march1stWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['march2ndWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['march3rdWeekIssueName'] }}</td>
                                <td colspan="2">{{ data['march4thWeekIssueName'] }}</td>
                                <td *ngIf="this.sundays(nexttoday | date:'yyyy', 2) > 4" colspan="2">{{
                                    data['march5thWeekIssueName'] }}</td>
                                <td colspan="2" rowspan="2" style="text-align: end;">
                                    <span *ngIf="this.sundays(nexttoday | date:'yyyy', 2) == 4">{{
                                        calculateTotalAmount(data['march1stWeekAmt'],data['march2ndWeekAmt'],data['march3rdWeekAmt'],data['march4thWeekAmt'])
                                        }}</span>
                                    <span *ngIf="this.sundays(nexttoday | date:'yyyy', 2) == 5">{{
                                        calculateTotalAmount(data['march1stWeekAmt'],data['march2ndWeekAmt'],data['march3rdWeekAmt'],data['march4thWeekAmt'],data['march5thWeekAmt'])
                                        }}</span>
                                </td>

                                <td rowspan="2" style="text-align: end;">{{ calculateTotalMarchEnd(data) }}</td>
                                <td rowspan="2" style="text-align: end;">{{ calculateForNextYear(data) }}</td>
                                <td rowspan="2" style="text-align: end;">{{ calculateUsedTillToday(data) }}</td>
                                <td rowspan="2" style="text-align: end;">{{ calculateRemainingTillMarch(data) }}</td>
                            </tr>

                            <!-- Second row: amounts -->
                            <tr class="amount" [style.background-color]="getAdvtColor(data.advt_name)"
                                style="text-align: end;">
                                <td>{{ data['april1stWeekAmt'] }}</td>
                                <td>{{ data['april1stWeekPageNo'] }}</td>
                                <td>{{ data['april2ndWeekAmt'] }}</td>
                                <td>{{ data['april2ndWeekPageNo'] }}</td>
                                <td>{{ data['april3rdWeekAmt'] }}</td>
                                <td>{{ data['april3rdWeekPageNo'] }}</td>
                                <td>{{ data['april4thWeekAmt'] }}</td>
                                <td>{{ data['april4thWeekPageNo'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 3) > 4">{{ data['april5thWeekAmt'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 3) > 4">{{ data['april5thWeekPageNo'] }}
                                </td>

                                <td>{{ data['may1stWeekAmt'] }}</td>
                                <td>{{ data['may1stWeekPageNo'] }}</td>
                                <td>{{ data['may2ndWeekAmt'] }}</td>
                                <td>{{ data['may2ndWeekPageNo'] }}</td>
                                <td>{{ data['may3rdWeekAmt'] }}</td>
                                <td>{{ data['may3rdWeekPageNo'] }}</td>
                                <td>{{ data['may4thWeekAmt'] }}</td>
                                <td>{{ data['may4thWeekPageNo'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 4) > 4">{{ data['may5thWeekAmt'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 4) > 4">{{ data['may5thWeekPageNo'] }}</td>

                                <td>{{ data['june1stWeekAmt'] }}</td>
                                <td>{{ data['june1stWeekPageNo'] }}</td>
                                <td>{{ data['june2ndWeekAmt'] }}</td>
                                <td>{{ data['june2ndWeekPageNo'] }}</td>
                                <td>{{ data['june3rdWeekAmt'] }}</td>
                                <td>{{ data['june3rdWeekPageNo'] }}</td>
                                <td>{{ data['june4thWeekAmt'] }}</td>
                                <td>{{ data['june4thWeekPageNo'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 5) > 4">{{ data['june5thWeekAmt'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 5) > 4">{{ data['june5thWeekPageNo'] }}
                                </td>

                                <td>{{ data['july1stWeekAmt'] }}</td>
                                <td>{{ data['july1stWeekPageNo'] }}</td>
                                <td>{{ data['july2ndWeekAmt'] }}</td>
                                <td>{{ data['july2ndWeekPageNo'] }}</td>
                                <td>{{ data['july3rdWeekAmt'] }}</td>
                                <td>{{ data['july3rdWeekPageNo'] }}</td>
                                <td>{{ data['july4thWeekAmt'] }}</td>
                                <td>{{ data['july4thWeekPageNo'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 6) > 4">{{ data['july5thWeekAmt'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 6) > 4">{{ data['july5thWeekPageNo'] }}
                                </td>

                                <td>{{ data['august1stWeekAmt'] }}</td>
                                <td>{{ data['august1stWeekPageNo'] }}</td>
                                <td>{{ data['august2ndWeekAmt'] }}</td>
                                <td>{{ data['august2ndWeekPageNo'] }}</td>
                                <td>{{ data['august3rdWeekAmt'] }}</td>
                                <td>{{ data['august3rdWeekPageNo'] }}</td>
                                <td>{{ data['august4thWeekAmt'] }}</td>
                                <td>{{ data['august4thWeekPageNo'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 7) > 4">{{ data['august5thWeekAmt'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 7) > 4">{{ data['august5thWeekPageNo'] }}
                                </td>

                                <td>{{ data['september1stWeekAmt'] }}</td>
                                <td>{{ data['september1stWeekPageNo'] }}</td>
                                <td>{{ data['september2ndWeekAmt'] }}</td>
                                <td>{{ data['september2ndWeekPageNo'] }}</td>
                                <td>{{ data['september3rdWeekAmt'] }}</td>
                                <td>{{ data['september3rdWeekPageNo'] }}</td>
                                <td>{{ data['september4thWeekAmt'] }}</td>
                                <td>{{ data['september4thWeekPageNo'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 8) > 4">{{ data['september5thWeekAmt'] }}
                                </td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 8) > 4">{{ data['september5thWeekPageNo']
                                    }}</td>

                                <td>{{ data['october1stWeekAmt'] }}</td>
                                <td>{{ data['october1stWeekPageNo'] }}</td>
                                <td>{{ data['october2ndWeekAmt'] }}</td>
                                <td>{{ data['october2ndWeekPageNo'] }}</td>
                                <td>{{ data['october3rdWeekAmt'] }}</td>
                                <td>{{ data['october3rdWeekPageNo'] }}</td>
                                <td>{{ data['october4thWeekAmt'] }}</td>
                                <td>{{ data['october4thWeekPageNo'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 9) > 4">{{ data['october5thWeekAmt'] }}
                                </td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 9) > 4">{{ data['october5thWeekPageNo'] }}
                                </td>

                                <td>{{ data['november1stWeekAmt'] }}</td>
                                <td>{{ data['november1stWeekPageNo'] }}</td>
                                <td>{{ data['november2ndWeekAmt'] }}</td>
                                <td>{{ data['november2ndWeekPageNo'] }}</td>
                                <td>{{ data['november3rdWeekAmt'] }}</td>
                                <td>{{ data['november3rdWeekPageNo'] }}</td>
                                <td>{{ data['november4thWeekAmt'] }}</td>
                                <td>{{ data['november4thWeekPageNo'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 10) > 4">{{ data['november5thWeekAmt'] }}
                                </td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 10) > 4">{{ data['november5thWeekPageNo']
                                    }}</td>

                                <td>{{ data['december1stWeekAmt'] }}</td>
                                <td>{{ data['december1stWeekPageNo'] }}</td>
                                <td>{{ data['december2ndWeekAmt'] }}</td>
                                <td>{{ data['december2ndWeekPageNo'] }}</td>
                                <td>{{ data['december3rdWeekAmt'] }}</td>
                                <td>{{ data['december3rdWeekPageNo'] }}</td>
                                <td>{{ data['december4thWeekAmt'] }}</td>
                                <td>{{ data['december4thWeekPageNo'] }}</td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 11) > 4">{{ data['december5thWeekAmt'] }}
                                </td>
                                <td *ngIf="this.sundays(today | date:'yyyy', 11) > 4">{{ data['december5thWeekPageNo']
                                    }}</td>

                                <td>{{ data['january1stWeekAmt'] }}</td>
                                <td>{{ data['january1stWeekPageNo'] }}</td>
                                <td>{{ data['january2ndWeekAmt'] }}</td>
                                <td>{{ data['january2ndWeekPageNo'] }}</td>
                                <td>{{ data['january3rdWeekAmt'] }}</td>
                                <td>{{ data['january3rdWeekPageNo'] }}</td>
                                <td>{{ data['january4thWeekAmt'] }}</td>
                                <td>{{ data['january4thWeekPageNo'] }}</td>
                                <td *ngIf="this.sundays(nexttoday | date:'yyyy', 0) > 4">{{ data['january5thWeekAmt'] }}
                                </td>
                                <td *ngIf="this.sundays(nexttoday | date:'yyyy', 0) > 4">{{ data['january5thWeekPageNo']
                                    }}</td>

                                <td>{{ data['feb1stWeekAmt'] }}</td>
                                <td>{{ data['feb1stWeekPageNo'] }}</td>
                                <td>{{ data['feb2ndWeekAmt'] }}</td>
                                <td>{{ data['feb2ndWeekPageNo'] }}</td>
                                <td>{{ data['feb3rdWeekAmt'] }}</td>
                                <td>{{ data['feb3rdWeekPageNo'] }}</td>
                                <td>{{ data['feb4thWeekAmt'] }}</td>
                                <td>{{ data['feb4thWeekPageNo'] }}</td>
                                <td *ngIf="this.sundays(nexttoday | date:'yyyy', 1) > 4">{{ data['feb5thWeekAmt'] }}
                                </td>
                                <td *ngIf="this.sundays(nexttoday | date:'yyyy', 1) > 4">{{ data['feb5thWeekPageNo'] }}
                                </td>

                                <td>{{ data['march1stWeekAmt'] }}</td>
                                <td>{{ data['march1stWeekPageNo'] }}</td>
                                <td>{{ data['march2ndWeekAmt'] }}</td>
                                <td>{{ data['march2ndWeekPageNo'] }}</td>
                                <td>{{ data['march3rdWeekAmt'] }}</td>
                                <td>{{ data['march3rdWeekPageNo'] }}</td>
                                <td>{{ data['march4thWeekAmt'] }}</td>
                                <td>{{ data['march4thWeekPageNo'] }}</td>
                                <td *ngIf="this.sundays(nexttoday | date:'yyyy', 2) > 4">{{ data['march5thWeekAmt'] }}
                                </td>
                                <td *ngIf="this.sundays(nexttoday | date:'yyyy', 2) > 4">{{ data['march5thWeekPageNo']
                                    }}</td>
                            </tr>
                        </ng-container>

                        <!-- Group total row -->
                        <tr [style.background-color]="getGroupColor(groupIndex)" style="text-align: end;">
                            <td class="fixed-col col-1" [style.background-color]="getGroupColor(groupIndex)"></td>
                            <td style="font-weight: 600;" class="fixed-col col-2"
                                [style.background-color]="getGroupColor(groupIndex)">{{ group.name }} - एकूण</td>
                            <td class="fixed-col col-3" [style.background-color]="getGroupColor(groupIndex)"></td>
                            <td class="fixed-col col-4" [style.background-color]="getGroupColor(groupIndex)"></td>
                            <td class="fixed-col col-5" style="text-align: end;"
                                [style.background-color]="getGroupColor(groupIndex)">{{
                                group.contract_prev_bal }}</td>
                            <td class="fixed-col col-7" style="text-align: end;"
                                [style.background-color]="getGroupColor(groupIndex)">{{
                                group.contract_amt }}</td>
                            <td class="fixed-col col-8" style="text-align: end;"
                                [style.background-color]="getGroupColor(groupIndex)">{{
                                group.contract_discnt_amt }}</td>
                            <td class="fixed-col col-9" style="text-align: end;"
                                [style.background-color]="getGroupColor(groupIndex)">{{
                                group.contract_net_amt }}</td>
                            <td class="fixed-col col-10" style="text-align: end;"
                                [style.background-color]="getGroupColor(groupIndex)">{{
                                group.contract_net_gst_amt }}</td>
                            <td class="fixed-col col-11" style="text-align: end;"
                                [style.background-color]="getGroupColor(groupIndex)">{{
                                calculateTotalWithPrevBal(group.contract_prev_bal, group.contract_net_total) }}</td>

                            <!-- APRIL -->
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 3) > 4" colspan="2"></td>
                            <td colspan="2" style="font-weight:bold;text-align: end !important;">{{
                                calculateGroupMonthTotal(group, 'april') }}
                            </td>

                            <!-- MAY -->
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 4) > 4" colspan="2"></td>
                            <td colspan="2" style="font-weight:bold;text-align: end !important;">{{
                                calculateGroupMonthTotal(group, 'may') }}</td>

                            <!-- JUNE -->
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 5) > 4" colspan="2"></td>
                            <td colspan="2" style="font-weight:bold;text-align: end !important;">{{
                                calculateGroupMonthTotal(group, 'june') }}</td>

                            <!-- JULY -->
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 6) > 4" colspan="2"></td>
                            <td colspan="2" style="font-weight:bold;text-align: end !important;">{{
                                calculateGroupMonthTotal(group, 'july') }}</td>

                            <!-- AUGUST -->
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 7) > 4" colspan="2"></td>
                            <td colspan="2" style="font-weight:bold;text-align: end !important;">{{
                                calculateGroupMonthTotal(group, 'august') }}
                            </td>

                            <!-- SEPTEMBER -->
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 8) > 4" colspan="2"></td>
                            <td colspan="2" style="font-weight:bold;text-align: end !important;">{{
                                calculateGroupMonthTotal(group, 'september') }}
                            </td>

                            <!-- OCTOBER -->
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 9) > 4" colspan="2"></td>
                            <td colspan="2" style="font-weight:bold;text-align: end !important;">{{
                                calculateGroupMonthTotal(group, 'october') }}
                            </td>

                            <!-- NOVEMBER -->
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 10) > 4" colspan="2"></td>
                            <td colspan="2" style="font-weight:bold;text-align: end !important;">{{
                                calculateGroupMonthTotal(group, 'november') }}
                            </td>

                            <!-- DECEMBER -->
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 11) > 4" colspan="2"></td>
                            <td colspan="2" style="font-weight:bold;text-align: end !important;">{{
                                calculateGroupMonthTotal(group, 'december') }}
                            </td>

                            <!-- JANUARY -->
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td *ngIf="this.sundays(nexttoday | date:'yyyy', 0) > 4" colspan="2"></td>
                            <td colspan="2" style="font-weight:bold;text-align: end !important;">{{
                                calculateGroupMonthTotal(group, 'january') }}
                            </td>

                            <!-- FEB -->
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td *ngIf="this.sundays(nexttoday | date:'yyyy', 1) > 4" colspan="2"></td>
                            <td colspan="2" style="font-weight:bold;text-align: end !important;">{{
                                calculateGroupMonthTotal(group, 'feb') }}</td>

                            <!-- MARCH -->
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td colspan="2"></td>
                            <td *ngIf="this.sundays(nexttoday | date:'yyyy', 2) > 4" colspan="2"></td>
                            <td colspan="2" style="font-weight:bold;text-align: end !important;">{{
                                calculateGroupMonthTotal(group, 'march') }}
                            </td>

                            <!-- FINAL TOTALS -->
                            <td style="font-weight:bold;text-align: end;">{{ calculateGroupTotals(group).totalMarchEnd
                                }}</td>
                            <td style="font-weight:bold;text-align: end;">{{ calculateGroupTotals(group).totalNextYear
                                }}</td>
                            <td style="font-weight:bold;text-align: end;">{{
                                calculateGroupTotals(group).totalUsedTillToday }}</td>
                            <td style="font-weight:bold;text-align: end;">{{ calculateGroupTotals(group).totalRemaining
                                }}</td>
                        </tr>

                    </ng-container>
                </ng-container>

                <!-- Grand Total row -->
                <tr
                    style="background-color: rgb(248, 246, 246); color: rgb(12, 12, 12); font-weight: bold; text-align: end; border-top: 3px solid #000;">
                    <td class="fixed-col col-1"></td>
                    <td class="fixed-col col-2" style="font-size: large;">एकूण</td>
                    <td class="fixed-col col-3"></td>
                    <td class="fixed-col col-4"></td>
                    <td class="fixed-col col-5" style="text-align: end;">{{ calculateGrandTotals().contract_prev_bal }}
                    </td>
                    <td class="fixed-col col-7" style="text-align: end;">{{ calculateGrandTotals().contract_amt }}</td>
                    <td class="fixed-col col-8" style="text-align: end;">{{ calculateGrandTotals().contract_discnt_amt
                        }}</td>
                    <td class="fixed-col col-9" style="text-align: end;">{{ calculateGrandTotals().contract_net_amt }}
                    </td>
                    <td class="fixed-col col-10" style="text-align: end;">{{ calculateGrandTotals().contract_net_gst_amt
                        }}</td>
                    <td class="fixed-col col-11" style="text-align: end;">
                        {{ calculateTotalWithPrevBal(calculateGrandTotals().contract_prev_bal,
                        calculateGrandTotals().contract_net_total) }}
                    </td>

                    <!-- APRIL -->
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td *ngIf="this.sundays(today | date:'yyyy', 3) > 4" colspan="2"></td>
                    <td colspan="2" style="font-weight:bold;text-align: end !important;">{{ getMonthTotal('april') }}
                    </td>

                    <!-- MAY -->
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td *ngIf="this.sundays(today | date:'yyyy', 4) > 4" colspan="2"></td>
                    <td colspan="2" style="font-weight:bold;text-align: end !important;">{{ getMonthTotal('may') }}</td>

                    <!-- JUNE -->
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td *ngIf="this.sundays(today | date:'yyyy', 5) > 4" colspan="2"></td>
                    <td colspan="2" style="font-weight:bold;text-align: end !important;">{{ getMonthTotal('june') }}
                    </td>

                    <!-- JULY -->
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td *ngIf="this.sundays(today | date:'yyyy', 6) > 4" colspan="2"></td>
                    <td colspan="2" style="font-weight:bold;text-align: end !important;">{{ getMonthTotal('july') }}
                    </td>

                    <!-- AUGUST -->
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td *ngIf="this.sundays(today | date:'yyyy', 7) > 4" colspan="2"></td>
                    <td colspan="2" style="font-weight:bold;text-align: end !important;">{{ getMonthTotal('august') }}
                    </td>

                    <!-- SEPTEMBER -->
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td *ngIf="this.sundays(today | date:'yyyy', 8) > 4" colspan="2"></td>
                    <td colspan="2" style="font-weight:bold;text-align: end !important;">{{ getMonthTotal('september')
                        }}</td>

                    <!-- OCTOBER -->
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td *ngIf="this.sundays(today | date:'yyyy', 9) > 4" colspan="2"></td>
                    <td colspan="2" style="font-weight:bold;text-align: end !important;">{{ getMonthTotal('october') }}
                    </td>

                    <!-- NOVEMBER -->
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td *ngIf="this.sundays(today | date:'yyyy', 10) > 4" colspan="2"></td>
                    <td colspan="2" style="font-weight:bold;text-align: end !important;">{{ getMonthTotal('november') }}
                    </td>

                    <!-- DECEMBER -->
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td *ngIf="this.sundays(today | date:'yyyy', 11) > 4" colspan="2"></td>
                    <td colspan="2" style="font-weight:bold;text-align: end !important;">{{ getMonthTotal('december') }}
                    </td>

                    <!-- JANUARY -->
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td *ngIf="this.sundays(nexttoday | date:'yyyy', 0) > 4" colspan="2"></td>
                    <td colspan="2" style="font-weight:bold;text-align: end !important;">{{ getMonthTotal('january') }}
                    </td>

                    <!-- FEB -->
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td *ngIf="this.sundays(nexttoday | date:'yyyy', 1) > 4" colspan="2"></td>
                    <td colspan="2" style="font-weight:bold;text-align: end !important;">{{ getMonthTotal('feb') }}</td>

                    <!-- MARCH -->
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td *ngIf="this.sundays(nexttoday | date:'yyyy', 2) > 4" colspan="2"></td>
                    <td colspan="2" style="font-weight:bold;text-align: end !important;">{{ getMonthTotal('march') }}
                    </td>

                    <!-- FINAL GRAND TOTALS -->
                    <td style="text-align: end;">{{ calculateGrandTotals().totalMarchEnd }}</td>
                    <td style="text-align: end;">{{ calculateGrandTotals().totalNextYear }}</td>
                    <td style="text-align: end;">{{ calculateGrandTotals().totalUsedTillToday }}</td>
                    <td style="text-align: end;">{{ calculateGrandTotals().totalRemaining }}</td>
                </tr>

            </tbody>
        </table>
    </div>
</div>